import { z } from 'zod'

import { PathField } from '../pathFields'
import { EasyBuilderConfigFormSectionType } from '../viewSectionTypes'

export const viewSectionFormSelectStorySchema = z.object({
  displayType: z.literal(EasyBuilderConfigFormSectionType.STORY_REPLY),

  path: z.object({
    storySelect: z.literal(PathField.STORY_SELECT),
    storyId: z.literal(PathField.STORY_ID),
  }),
})
